module.exports = __webpack_public_path__ + "static/media/dish6.96745674.jpg";